// Blog post metadata and excerpts
// Example posts have been archived to src/blogs/archived/
// Add your own blog posts here following this format:
/*
{
  id: 'your-blog-post-slug',
  title: 'Your Blog Post Title',
  date: 'Month Day, Year',
  readTime: 'X min read',
  tags: ['Tag1', 'Tag2', 'Tag3'],
  excerpt: `Your blog post excerpt or summary...`,
  fullContent: null
}
*/

export const blogPosts = [
  {
    id: 'the-choice-of-presence',
    title: 'The Choice of Presence',
    date: 'April 29, 2026',
    readTime: '5 min read',
    tags: ['Motherhood', 'Career', 'Identity', 'Modern Parenting', 'Leadership'],
    excerpt: `For a long time, I viewed my career and my personal life as two separate operating systems. When people talk about choosing to be present with their kids, they often use words like "taking a break" or the dreaded "career gap." But the more I analyzed the big picture, the more that term felt like a technical error. It's not a gap. It's a shift in management.`,
    fullContent: null
  },
  {
    id: 'the-role',
    title: 'The Role',
    date: 'April 22, 2026',
    readTime: '4 min read',
    tags: ['Motherhood', 'Modern Parenting', 'Identity', 'Mental Load'],
    excerpt: `There are things which one cannot understand fully until they experience it on their own. The joy of priceless moments and the brutal reality of it - motherhood taught me both. It's rewarding, it's fulfilling, and at the same time it's draining, it's challenging. The realization - it's not a role; it's the role.`,
    fullContent: null
  },
  {
    id: 'the-unfinished',
    title: 'The Unfinished',
    date: 'March 23, 2026',
    readTime: '5 min read',
    tags: ['Motherhood', 'Mental Load', 'Postpartum', 'Identity'],
    excerpt: `When we talk about motherhood, we cover everything — pregnancy, postpartum, mental load, newborn routines. But somewhere between all of that, something quieter happens. Something every mother feels but nobody really names. We start things and can't finish them. Every single day. As mothers, we enter the world of "The Unfinished".`,
    fullContent: null
  },
  {
    id: 'the-joy-i-forgot-to-mention',
    title: 'The Joy I Forgot to Mention',
    date: 'March 17, 2026',
    readTime: '4 min read',
    tags: ['Motherhood', 'Newborn', 'Gratitude', 'Postpartum'],
    excerpt: `After our baby was born, whenever someone asked me about how the newborn phase was going, the first thing that used to come out of my mouth was: *"oh, it's tiring. It's a lot. I'm exhausted."* Those words did come eventually — but only after I'd covered all the hard parts first. Now I wonder, amidst all that settling into new life — there were countless, priceless moments. The coos, the lifting of the neck, the bobbly head, the newborn scrunches. It was amazing. And we miss them a lot.`,
    fullContent: null
  },
  {
    id: 'the-sleep-chapter',
    title: 'The Sleep Chapter',
    date: 'March 9, 2026',
    readTime: '6 min read',
    tags: ['Motherhood', 'New Parents', 'Baby Sleep', 'Postpartum'],
    excerpt: `If you ask any parent about their newborn's sleep schedule, I can guarantee you'll get all sorts of answers filled with nostalgia, exhaustion, and joyful learnings. For us, it took two full years before I could say with any confidence that he actually slept for a few hours in one go. This is our story — not a guide, not a set of tips, just the honest account of how we found our rhythm in the middle of the night.`,
    fullContent: null
  },
  {
    id: 'why-the-debt',
    title: 'The Debt That Was Never Theirs to Carry',
    date: 'March 2, 2026',
    readTime: '5 min read',
    tags: ['Motherhood', 'Parenting', 'Culture', 'Breaking Stereotypes'],
    excerpt: `In many cultures and belief systems, there exists this unspoken notion of burdening a child with the debt of simply being born. I never really understood it. Questioned it? Absolutely, many times. Did I ever get a clear answer? Never. Until one day, when I became a mother — and everything became clear.`,
    fullContent: null
  },
  {
    id: 'the-silent-partner',
    title: 'The Silent Efforts of a Partner',
    date: 'February 22, 2026',
    readTime: '4 min read',
    tags: ['Motherhood', 'Relationships', 'Postpartum', 'Parenting Journey'],
    excerpt: `When two people start a serious relationship, it's just the two of them driving it forward. Then things change — a third person arrives. A baby's arrival tests everything in you: your patience, your resilience, your tolerance, and most importantly, the strength of your bond. In this piece, I want to talk about the person quietly working behind the scenes — The Silent Partner.`,
    fullContent: null
  },
  {
    id: 'the-isolation',
    title: 'The Isolation',
    date: 'February 17, 2026',
    readTime: '4 min read',
    tags: ['Motherhood', 'Postpartum', 'Breastfeeding', 'Mental Health'],
    excerpt: `Let's talk about one of the hardest parts of being a mother. The least understood, least talked about and most overwhelming state of a new mom. Nobody really understands it until it has been felt by themselves. A new mom, sitting on a rocking chair, nursing pillow around their body, feeding the baby for hours — while a whole world outside carries on...`,
    fullContent: null
  },
  {
    id: 'the-day-one',
    title: 'The Day ONE...',
    date: 'January 23, 2026',
    readTime: '3 min read',
    tags: ['Motherhood', 'New Parents', 'First Baby', 'Parenting Journey'],
    excerpt: `I remember, when we first got the two double solid lines - our world changed for real... in a happy way of course. We started preparing for everything: financial aspects, our home, how to manage home and work, researching everything. Things hit hard when we brought the baby home...`,
    fullContent: null
  },
  {
    id: 'lost-me-found-me',
    title: 'Lost Me; Found Me',
    date: 'January 14, 2026',
    readTime: '3 min read',
    tags: ['Motherhood', 'Self-Discovery', 'Personal Journey', 'Parenting'],
    excerpt: `When I thought about writing about my journey, these words echoed in my mind, like giving me some direction or nudging me towards something. I think this was it—a journey, a sense of belonging. Through my years of parenting, I felt like I literally lost me, faded somewhere; around many people but still isolated. But, for the past one year, I found a new me; renewed, invigorated me...`,
    fullContent: null
  }
];

// Sort posts by date (newest first)
export const getSortedPosts = () => {
  return [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));
};

// Get posts by tag
export const getPostsByTag = (tag) => {
  return blogPosts.filter(post => post.tags.includes(tag));
};

// Get single post by ID
export const getPostById = (id) => {
  return blogPosts.find(post => post.id === id);
};
